import React from 'react';

// Constants
import { getQsgCompletionData } from './QuickStartGuideCompletionModalData.constants';

// Components
import NewFeatureCarouselModal from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal';
import { WpButton } from 'Wpds/components/button';
import { useTranslation } from 'Shared/contexts/TranslationsContext';

type Props = {
  isOpen: boolean;
  toggleIsOpen: () => void;
};

const QuickStartGuideCompletionModal = ({ isOpen, toggleIsOpen }: Props) => {
  const { tr } = useTranslation();

  const handleGuidesLinkClick = () => {
    const element = document.createElement('a');
    element.href = 'https://docs.predictiveindex.com/perform/overview/getting-started-with-perform/';
    element.target = '_blank';
    element.rel = 'noopener noreferrer';
    document.body.appendChild(element);
    element.click();
    element.remove();
  };

  const data = getQsgCompletionData(tr);

  return (
    <NewFeatureCarouselModal
      isOpen={isOpen}
      toggleIsOpen={toggleIsOpen}
      data={data}
      additionalButton={
        <WpButton variant="tertiary" onClick={handleGuidesLinkClick}>
          {tr('perform.onboarding.qsg.complete.view_guides')}
        </WpButton>
      }
    />
  );
};

export default QuickStartGuideCompletionModal;
